import React from 'react';
import { Star, ShieldCheck, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full bg-cream pt-3 pb-8 sm:pt-6 sm:pb-10 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-81">
      <div className="max-w-6xl mx-auto" data-id="element-82">
        {/* Header Content */}
        <div className="flex flex-col items-center text-center mb-5 sm:mb-8" data-id="element-83">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-1.5 text-[10px] sm:text-xs font-bold tracking-wider text-navy shadow-sm mb-4 sm:mb-5 border border-gray-100 uppercase" data-id="element-84">
            <span className="w-2 h-2 rounded-full bg-primary" data-id="element-85"></span>
            SISTEMA DE PLANIFICACIÓN · GIMNASIA ARTÍSTICA INFANTIL
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl sm:text-4xl lg:text-5xl font-heading font-black leading-[1.35] sm:leading-[1.3] tracking-tight mb-5 sm:mb-7 max-w-4xl" data-id="element-86">
            <span className="text-navy underline decoration-4 underline-offset-4 sm:decoration-8 sm:underline-offset-8" data-id="element-87">
              Deja de buscar en Youtube<span className="text-primary" data-id="element-88">.</span>
            </span>
            <span className="block h-2 sm:h-4" aria-hidden="true" data-id="element-89"></span>
            <span className="text-primary underline decoration-4 underline-offset-4 sm:decoration-8 sm:underline-offset-8" data-id="element-90">
              Tus clases de gimnasia, planificadas con precisión en 5 Minutos.
            </span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15
        }} className="relative w-full max-w-2xl mb-6 sm:mb-8" data-id="element-91">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/fPUkbpkQhSy69UK4jPJ3dX/image_(2).webp" alt="Entrenadora de gimnasia con el ProfePack y sus 5 bonos" className="w-full h-auto object-cover aspect-[16/10] sm:aspect-[4/3]" data-id="element-93" />
            </div>
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-max max-w-[90%]" data-id="element-94">
              <div className="bg-primary text-white text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-lg flex items-center gap-2" data-id="element-95">
                <Zap className="w-4 h-4 fill-current" data-id="element-96" />
                Acceso inmediato · Acceso de por vida
              </div>
            </div>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-sm sm:text-lg text-gray-700 max-w-3xl mb-3 sm:mb-4 font-medium pt-[5px] pb-[5px]" data-id="element-97">
            Deja de improvisar. Con el ProfePack armas tu clase completa en 5
            minutos: progresión, seguridad y evaluación — todo resuelto en PDF.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="flex items-center gap-2 text-sm font-medium text-gray-600" data-id="element-98">
            <div className="flex text-primary" data-id="element-99">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-100" />)}
            </div>
            <span className="font-bold text-navy" data-id="element-101">4.9</span>
            <span data-id="element-102">· 500+ profes ya lo usan</span>
          </motion.div>
        </div>

        {/* CTA Card */}
        <div className="max-w-xl mx-auto" data-id="element-103">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="bg-white rounded-3xl p-5 sm:p-8 shadow-xl border border-gray-100 relative" data-id="element-104">
            <a href="#oferta" className="w-full bg-primary hover:bg-primary-hover text-white font-heading font-black text-lg sm:text-xl py-4 rounded-xl shadow-[0_4px_14px_0_rgba(241,90,41,0.39)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-105">
              Quiero el ProfePack
              <Zap className="w-5 h-5 fill-current" data-id="element-106" />
            </a>

            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-4 text-xs font-medium text-gray-500" data-id="element-107">
              <span className="flex items-center gap-1" data-id="element-108">
                <Zap className="w-3 h-3" data-id="element-109" /> Entrega inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-110">
                <CreditCard className="w-3 h-3" data-id="element-111" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-112">
                <ShieldCheck className="w-3 h-3" data-id="element-113" /> Garantía 7 días
              </span>
            </div>

            <div className="mt-6 text-center" data-id="element-114">
              <div className="inline-block bg-orange-50 text-primary text-xs font-bold px-3 py-1.5 rounded-full mb-2" data-id="element-115">
                Quedan 7 cupos de lanzamiento 04:02
              </div>
              <p className="text-xs text-gray-400 flex items-center justify-center gap-1" data-id="element-116">
                <span className="w-2 h-2 rounded-full bg-success animate-pulse" data-id="element-117"></span>
                24 personas viendo este producto ahora
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}